/*
TABLE ROW
Row alternating background colors and border rounded corners
*/

// Check if row should have alternate styling
export const isAlternateRow = (index) => index % 2 === 0;

export const getRowStyles = (index, theme) => {
  const isAlternate = isAlternateRow(index);
  return {
    backgroundColor: isAlternate
      ? theme.customBackgrounds.mediumBackground
      : "transparent",
    color: isAlternate ? "primary.black" : "primary.white",
    backdropFilter: "blur(12px)",
    borderRadius: isAlternate ? theme.borderRadius.small : 0,
    overflow: "hidden",
    "& td, & th": {
      border: "none",
      color: "primary.white",
    },
    "& td:first-of-type": {
      borderTopLeftRadius: isAlternate ? theme.borderRadius.small : 0,
      borderBottomLeftRadius: isAlternate ? theme.borderRadius.small : 0,
    },
    "& td:last-of-type": {
      borderTopRightRadius: isAlternate ? theme.borderRadius.small : 0,
      borderBottomRightRadius: isAlternate ? theme.borderRadius.small : 0,
    },
  };
};

/*
BUTTON futuristic style
*/
export const NAVIGATION_BUTTON_STYLES = {
  color: "primary.white",
  position: "relative",
  overflow: "hidden",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: "-100%",
    width: "100%",
    height: "100%",
    background:
      "linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)",
    transform: "skewX(-20deg)",
    transition: "left 0.6s ease",
  },
  "&:hover::before": {
    left: "100%",
  },
  "&:hover": {
    backgroundColor: "rgba(255,255,255,0.05)",
  },
  "&:disabled": {
    color: "rgba(255,255,255,0.3)",
  },
};
